import {
  PROFILE_ERROR,
  PROFILE_SUCCESS,
  EDIT_PROFILE,
  RESET_PROFILE_FLAG,
  EDIT_COMPANY,
  EDIT_COMPANY_ERROR,
  EDIT_COMPANY_SUCCESS,
  ADD_LOCATION,
  ADD_LOCATION_SUCCESS,
  ADD_LOCATION_ERROR,
  LOCATION_LIST,
  LOCATION_LIST_SUCCESS,
  LOCATION_LIST_ERROR,
  MANAGER_LIST,
  MANAGER_LIST_SUCCESS,
  MANAGER_LIST_ERROR,
  ASSIGN_LOCATION,
  ASSIGN_LOCATION_SUCCESS,
  ASSIGN_LOCATION_ERROR,
  GET_MANAGER_BY_ID,
  GET_MANAGER_BY_ID_SUCCESS,
  GET_MANAGER_BY_ID_ERROR,
  GET_EMPLOYEE_BY_LOCATION,
  GET_EMPLOYEE_BY_LOCATION_SUCCESS,
  GET_EMPLOYEE_BY_LOCATION_ERROR,
  UPDATE_MANAGER_DETAILS,
  UPDATE_MANAGER_DETAILS_SUCCESS,
  UPDATE_MANAGER_DETAILS_ERROR,
  DELETE_LOCATION,
  DELETE_LOCATION_SUCCESS,
  DELETE_LOCATION_ERROR,
  LOGIN_AS_MANAGER,
  LOGIN_AS_MANAGER_SUCCESS,
  LOGIN_AS_MANAGER_ERROR,
  LOGIN_AS_ADMIN,
  LOGIN_AS_ADMIN_SUCCESS,
  LOGIN_AS_ADMIN_ERROR,
  AVAILABLE_LOCATIONS,
  AVAILABLE_LOCATIONS_SUCCESS,
  AVAILABLE_LOCATIONS_ERROR,
  SKIP_LOCATION,
  SKIP_LOCATION_SUCCESS,
  SKIP_LOCATION_ERROR,
  GET_PARTICIPANT_BY_LOCATION,
  GET_PARTICIPANT_BY_LOCATION_SUCCESS,
  GET_PARTICIPANT_BY_LOCATION_ERROR,
  NOTIFICATION,
  NOTIFICATION_SUCCESS,
  NOTIFICATION_ERROR,
  FREE_NOTIFICATION,
  FREE_NOTIFICATION_SUCCESS,
  FREE_NOTIFICATION_ERROR,
  IS_USER_VALID,
  GET_USER_DATA,
  GET_USER_DATA_SUCCESS,
  ADD_ADMIN_SWITCH_ACCOUNT,
  ADD_ADMIN_SWITCH_ACCOUNT_SUCCESS,
  ADD_ADMIN_SWITCH_ACCOUNT_FAIL,
} from "./actionTypes";

export const addAdminSwitchAccount = (data = {}, onSuccess = () => {}, onError = () => {}) => {
  return {
    type: ADD_ADMIN_SWITCH_ACCOUNT,
    payload: { data, onSuccess, onError },
  };
};

export const addAdminSwitchAccountSuccess = data => {
  return {
    type: ADD_ADMIN_SWITCH_ACCOUNT_SUCCESS,
    payload: data,
  };
};

export const addAdminSwitchAccountFail = data => {
  return {
    type: ADD_ADMIN_SWITCH_ACCOUNT_FAIL,
    payload: data,
  };
};

export const getUserData = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_USER_DATA,
  payload: { data, onSuccess, onError },
});

export const getUserDataSuccess = (data = {}) => ({
  type: GET_USER_DATA_SUCCESS,
  payload: data,
});

export const isUserValid = (data, history) => {
  return {
    type: IS_USER_VALID,
    payload: { data, history },
  };
};

export const skipLocation = data => {
  return {
    type: SKIP_LOCATION,
    payload: data,
  };
};

export const skipLocationSuccess = data => {
  return {
    type: SKIP_LOCATION_SUCCESS,
    payload: data,
  };
};

export const skipLocationFail = data => {
  return {
    type: SKIP_LOCATION_ERROR,
    payload: data,
  };
};

export const freeNotificatins = (data, dispatch) => {
  return {
    type: FREE_NOTIFICATION,
    payload: { data, dispatch },
  };
};

export const freeNotificatinsSuccess = data => {
  return {
    type: FREE_NOTIFICATION_SUCCESS,
    payload: data,
  };
};

export const freeNotificatinsFail = data => {
  return {
    type: FREE_NOTIFICATION_ERROR,
    payload: data,
  };
};

export const getMyNotificatins = data => {
  return {
    type: NOTIFICATION,
    payload: data,
  };
};

export const getMyNotificatinsSuccess = data => {
  return {
    type: NOTIFICATION_SUCCESS,
    payload: data,
  };
};

export const getMyNotificatinsFail = data => {
  return {
    type: NOTIFICATION_ERROR,
    payload: data,
  };
};

export const locationsList = data => {
  return {
    type: AVAILABLE_LOCATIONS,
    payload: data,
  };
};

export const LocationsListSuccess = data => {
  return {
    type: AVAILABLE_LOCATIONS_SUCCESS,
    payload: data,
  };
};

export const LocationsListFail = data => {
  return {
    type: AVAILABLE_LOCATIONS_ERROR,
    payload: data,
  };
};

export const loginAsManager = (data, history) => {
  return {
    type: LOGIN_AS_MANAGER,
    payload: { data, history },
  };
};

export const loginAsManagerSuccess = data => {
  return {
    type: LOGIN_AS_MANAGER_SUCCESS,
    payload: data,
  };
};

export const loginAsManagerFail = data => {
  return {
    type: LOGIN_AS_MANAGER_ERROR,
    payload: data,
  };
};

export const loginAsAdmin = (data, history) => {
  return {
    type: LOGIN_AS_ADMIN,
    payload: { data, history },
  };
};

export const loginAsAdminSuccess = data => {
  return {
    type: LOGIN_AS_ADMIN_SUCCESS,
    payload: data,
  };
};

export const loginAsAdminFail = data => {
  return {
    type: LOGIN_AS_ADMIN_ERROR,
    payload: data,
  };
};

export const deleteLocation = (data = {}, onSuccess = () => {}, onError = () => {}) => {
  return {
    type: DELETE_LOCATION,
    payload: { data, onSuccess, onError },
  };
};

export const deleteLocationSuccess = data => {
  return {
    type: DELETE_LOCATION_SUCCESS,
    payload: data,
  };
};

export const deleteLocationFail = data => {
  return {
    type: DELETE_LOCATION_ERROR,
    payload: data,
  };
};

export const updateManager = data => {
  return {
    type: UPDATE_MANAGER_DETAILS,
    payload: data,
  };
};

export const updateManagerSuccess = data => {
  return {
    type: UPDATE_MANAGER_DETAILS_SUCCESS,
    payload: data,
  };
};

export const updateManagerFail = data => {
  return {
    type: UPDATE_MANAGER_DETAILS_ERROR,
    payload: data,
  };
};

export const getEmployeeByLocation = data => {
  return {
    type: GET_EMPLOYEE_BY_LOCATION,
    payload: data,
  };
};

export const getEmployeeByLocationSuccess = data => {
  return {
    type: GET_EMPLOYEE_BY_LOCATION_SUCCESS,
    payload: data,
  };
};

export const getEmployeeByLocationFail = data => {
  return {
    type: GET_EMPLOYEE_BY_LOCATION_ERROR,
    payload: data,
  };
};

export const getParticipantByLocation = data => {
  return {
    type: GET_PARTICIPANT_BY_LOCATION,
    payload: data,
  };
};

export const getParticipantByLocationSuccess = data => {
  return {
    type: GET_PARTICIPANT_BY_LOCATION_SUCCESS,
    payload: data,
  };
};

export const getParticipantByLocationFail = data => {
  return {
    type: GET_PARTICIPANT_BY_LOCATION_ERROR,
    payload: data,
  };
};

export const getManagerDetails = data => {
  return {
    type: GET_MANAGER_BY_ID,
    payload: data,
  };
};

export const getManagerDetailsSuccess = data => {
  return {
    type: GET_MANAGER_BY_ID_SUCCESS,
    payload: data,
  };
};

export const getManagerDetailsFail = data => {
  return {
    type: GET_MANAGER_BY_ID_ERROR,
    payload: data,
  };
};

export const assignLocations = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ASSIGN_LOCATION,
  payload: { data, onSuccess, onError },
});

export const assignLocationsSuccess = data => {
  return {
    type: ASSIGN_LOCATION_SUCCESS,
    payload: data,
  };
};

export const assignLocationsFail = data => {
  return {
    type: ASSIGN_LOCATION_ERROR,
    payload: data,
  };
};

export const getManagerList = data => {
  return {
    type: MANAGER_LIST,
    payload: data,
  };
};

export const getManagerListSuccess = data => {
  return {
    type: MANAGER_LIST_SUCCESS,
    payload: data,
  };
};

export const getManagerListFail = data => {
  return {
    type: MANAGER_LIST_ERROR,
    payload: data,
  };
};

export const getLocationsList = data => {
  return {
    type: LOCATION_LIST,
    payload: data,
  };
};

export const getLocationsListSuccess = data => {
  return {
    type: LOCATION_LIST_SUCCESS,
    payload: data,
  };
};

export const getLocationsListFail = data => {
  return {
    type: LOCATION_LIST_ERROR,
    payload: data,
  };
};

export const addLocation = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_LOCATION,
  payload: { data, onSuccess, onError },
});

export const addLocationSuccess = data => {
  return {
    type: ADD_LOCATION_SUCCESS,
    payload: data,
  };
};

export const addLocationFail = data => {
  return {
    type: ADD_LOCATION_ERROR,
    payload: data,
  };
};

export const editCompany = data => {
  return {
    type: EDIT_COMPANY,
    payload: data,
  };
};

export const editCompanySuccess = data => {
  return {
    type: EDIT_COMPANY_SUCCESS,
    payload: data,
  };
};

export const editCompanyFail = data => {
  return {
    type: EDIT_COMPANY_ERROR,
    payload: data,
  };
};

export const editProfile = user => {
  return {
    type: EDIT_PROFILE,
    payload: user,
  };
};

export const profileSuccess = msg => {
  return {
    type: PROFILE_SUCCESS,
    payload: msg,
  };
};

export const profileError = error => {
  return {
    type: PROFILE_ERROR,
    payload: error,
  };
};

export const resetProfileFlag = error => {
  return {
    type: RESET_PROFILE_FLAG,
  };
};
